import { PageController } from '@client/components/_core/layout/PageController';
import { ORG_CONFIG_PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Settings } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration')({
    staticData: {
        breadcrumb: {
            title: 'Control centre',
        },
        // CUR-2808: the Accounts role reaches Financials › Bank account. Every section layout and page
        // directly under this layout sets its own permissions (pages deeper down inherit their section's),
        // so this opens only the layout itself to them, not another page: `configuration-access.test.ts`.
        permissions: [...ORG_CONFIG_PERMISSIONS, 'org_bank_account:read'],
        ui: {
            icon: Settings,
        },
    },
    component: Configuration,
});

function Configuration() {
    return (
        <PageController route={Route}>
            <Outlet />
        </PageController>
    );
}
